export enum ChannelValue {
  STORE_CUSTOMER = "fdc31d4e-e2b7-44c9-98aa-aec3612e498b",
  STORE_FACTORY = "78fb8946-65ed-49d6-bc9b-7ef9843e77ba",
  PRIVATE = "37257159-ac7c-452e-953d-a0c8016ba7ce",
}
